/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

/**
 * Contract resource endpoints.
 */
@Injectable({
  providedIn: 'root',
})
export class ContractsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation accept
   */
  static readonly AcceptPath = '/merchants/{merchantId}/contract';

  /**
   * Accepts the contract of specified merchant.
   *
   * The caller merchant accepts the contract of merchant specified by `merchantId` in the URL.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accept()` instead.
   *
   * This method doesn't expect any request body.
   */
  accept$Response(
    params: {
      /**
       * The ID of merchant having contract to be accepted
       */
      merchantId: string;

      /**
       * The SHA-256 hash of document.
       */
      'If-Match': string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ContractsService.AcceptPath,
      'post'
    );
    if (params) {
      rb.path('merchantId', params.merchantId, {});
      rb.header('If-Match', params['If-Match'], {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * Accepts the contract of specified merchant.
   *
   * The caller merchant accepts the contract of merchant specified by `merchantId` in the URL.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accept$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accept(
    params: {
      /**
       * The ID of merchant having contract to be accepted
       */
      merchantId: string;

      /**
       * The SHA-256 hash of document.
       */
      'If-Match': string;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.accept$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }
}
